import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { IonicModule, ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { ICustomKegMon, ICustomKegMonVM } from 'app/models/customKegMon';
import * as fromCustomKegMon from 'app/state/custom_keg_mon';
import * as fromTap from 'app/state/tap';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-select-custom-keg',
  templateUrl: './select-custom-keg-mon.component.html',
  styleUrls: ['./select-custom-keg-mon.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class SelectCustomKegMonComponent implements OnInit {

  items$!: Observable<ICustomKegMonVM[]>;

  constructor(
    private customKegMonStore: Store<fromCustomKegMon.State>,
    private modalController: ModalController,
  ) { }

  ngOnInit() {
    this.items$ = this.customKegMonStore.select(fromTap.getCustomKegMonsWithTap);

  }

  closeModal() {
    this.modalController.dismiss();
  }

  async selectItem(item: ICustomKegMonVM) {
    this.modalController.dismiss({
      item
    });
  }
}
